<template>
  <div class="question-content">
    <div class="inner-header">
      <span class="type-name">{{question.typeName}}</span>
    </div>
    <div class="scroll-box">
      <div class="question-desc question-render-container"></div>
      <div class="question-wrap" v-if="!refreshDom">
        <div class="blank-wrap" v-if="question.typeId === 20">
          <input
            type="text"
            placeholder="请在这里输入答案"
            class="blank-fill"
            v-model="currentAnswer"
            :class="{ 'is-correct-input': isCorrect, 'is-error-input': !isCorrect }"
          >
          <div class="flag">
            <i v-if="isCorrect" class="icon-correct"></i>
            <i v-if="!isCorrect && currentAnswer" class="icon-error"></i>
          </div>
          <span
            class="no-answer"
            v-if="!currentAnswer"
          >未作答</span>
        </div>
        <ul class="option-wrap" v-if="question.typeId === 1">
          <li class="option"
              v-for="(option, index) in question.choice.choices"
              :key="index"
              :class="{
                'is-correct-input': option.submit_id === correctAnswer,
                'is-error-input': option.submit_id === currentAnswer && !isCorrect
              }">
            <div class="option-name-wrap">
              <span>{{order[index]}}</span>
            </div>
            <div class="option-content">
              <p class="desc" v-html="$xss(option.text)" v-if="option.text"></p>
              <img :src="option.image" alt="" class="image">
            </div>
            <div class="flag">
               <i v-if="option.submit_id === correctAnswer && currentAnswer" class="icon-correct"></i>
               <i v-if="option.submit_id === currentAnswer && !isCorrect" class="icon-error"></i>
            </div>
            <span
              class="no-answer"
              v-if="option.submit_id === correctAnswer && !currentAnswer"
            >未作答</span>
          </li>
        </ul>
        <ul class="option-wrap" v-if="question.typeId === 2">
          <li class="option"
              v-for="(option, index) in question.choice.choices"
              :key="index"
              :class="{
                'is-correct-input': correctAnswer.indexOf(option.submit_id) !== -1,
                'is-error-input': currentAnswer.indexOf(option.submit_id) !== -1 && correctAnswer.indexOf(option.submit_id) === -1
              }"
          >
            <div class="option-name-wrap">
              <span>{{order[index]}}</span>
            </div>
            <div class="option-content">
              <p class="desc" v-html="$xss(option.text)" v-if="option.text"></p>
              <img :src="option.image" alt="" class="image">
            </div>
            <div class="flag">
              <i v-if="correctAnswer.indexOf(option.submit_id) !== -1 && currentAnswer.length > 0" class="icon-correct"></i>
              <i
                v-if="currentAnswer.indexOf(option.submit_id) !== -1 && correctAnswer.indexOf(option.submit_id) === -1"
                class="icon-error"
              ></i>
            </div>
            <span
              class="no-answer"
              v-if="correctAnswer.indexOf(option.submit_id) !== -1 && !currentAnswer.length"
            >未作答</span>
          </li>
        </ul>
        <div class="tool-wrap" v-if="question.questionType === 0 || question.questionType === 2 || question.questionType === 3">
          <iframe :src="toolUrl" ref="editor" class="editor" :class="{'full-screen': editorFullScreen}" allow="microphone;camera;midi;encrypted-media;"></iframe>
          <div class="full-screen-btn" v-show="editorFullScreen">
            <button class="title-tip">
              <span class="tip" v-html="$xss(question.rawDescription)"></span>
            </button>
            <button class="out-full-screen" @click="outFullScreen" v-show="editorFullScreen"></button>
          </div>
          <div class="toAnswer" @click="showFullScreen">全屏查看<span class="arrow"></span></div>
          <div class="mask"></div>
        </div>
        <!--python新题型-->
        <div class="new-type-wrap" v-if="question.questionType === 1">
          <button class="data-download" @click="downloadExamData(question.uploadUrl)"><i class="download-icon"></i>考试资料下载</button>
          <div class="upload-wrap">
            <p class="tip">请根据题目提示，打开海龟编辑器进行作答，作答完成根据要求上传答案</p>
            <div class="answer-wrap" v-if="currentAnswer">
              <i class="python-icon"></i>
              <div class="answer-info">
                <p class="file-name">{{currentAnswer.split('/')[currentAnswer.split('/').length - 1]}}</p>
                <p class="upload-time">{{currentAnswer.split('/')[currentAnswer.split('/').length - 2] | date('Y-m-d H:i')}} 上传成功</p>
              </div>
              <span class="change-btn" @click="downloadExamData(currentAnswer)">查看作品</span>
            </div>
            <p v-else style="font-size: 14px; color: #999">考生未上传答案</p>
          </div>
        </div>
        <ul class="option-wrap" v-if="question.typeId === 6">
          <li class="option"
              v-for="(option, index) in judgeList"
              :key="index"
              :class="{
                'is-correct-input': option.value === correctAnswer,
                'is-error-input': option.value === currentAnswer && !isCorrect
              }"
          >
            <div class="option-name-wrap">
              <span>{{order[index]}}</span>
            </div>
            <div class="option-content">
              <p class="desc">{{option.name}}</p>
            </div>
            <div class="flag">
              <i v-if="option.value === correctAnswer && currentAnswer" class="icon-correct"></i>
              <i v-if="option.value === currentAnswer && !isCorrect" class="icon-error"></i>
            </div>
            <span class="no-answer" v-if="option.value === correctAnswer && !currentAnswer">未作答</span>
          </li>
        </ul>
      </div>
      <div class="answer-wrap">
        <p>
          本题得分：
          <span v-if="question.typeId === 10">
            {{ question.normal ? '自动判分失败' : question.score }}
          </span>
          <span v-else-if="question.typeId === 11">待批改</span>
          <span v-else>{{ question.score }}</span>
        </p>
        <div v-if="question.typeId === 1">
          <p>正确答案：{{ order[correctAnswer-1] }}</p>
          <p>你的答案：{{ !currentAnswer ? '未作答' : order[currentAnswer-1] }}</p>
        </div>
        <div v-if="question.typeId === 2">
          <p>正确答案：
            <span v-for="item in correctAnswer" :key="item+'correctAnswer'">{{ order[item-1] }}</span>
          </p>
          <p>你的答案：
            <span v-if="!currentAnswer.length">未作答</span>
            <span v-else v-for="item in currentAnswer" :key="item+'correctAnswer2'">{{ order[item-1] }}</span>
          </p>
        </div>
        <div v-if="question.typeId === 6">
          <p>正确答案：
            {{ order[correctAnswer-1] }}
          </p>
          <p>你的答案：
            {{ !currentAnswer ? '未作答' : order[currentAnswer-1] }}
          </p>
        </div>
        <div v-if="question.typeId === 10">
          <p>测试数据：
            <span v-if="!correctAnswer">暂无参考数据</span>
            <el-table
              v-else
              :data="correctAnswer"
              style="width: 400px; margin: 10px 0;"
              border
            >
              <el-table-column
                prop="input"
                label="输入">
              </el-table-column>
              <el-table-column
                prop="output"
                label="输出">
              </el-table-column>
            </el-table>
          </p>
          <!--<p>你的答案：-->
            <!--<span v-html="currentAnswer"></span>-->
          <!--</p>-->
        </div>
        <div v-if="question.typeId === 11">
          <p>参考答案：
            <span v-if="!correctAnswer">无</span>
            <a v-else :href="correctAnswer" class=link-color>{{ question.kitten.answer_bcm.filename }}</a>
          </p>
          <!--<p>你的答案：-->
            <!--<a :href="currentAnswer" class=link-color>{{ question.kitten.answer_bcm.filename }}</a>-->
          <!--</p>-->
        </div>
        <div v-if="question.typeId === 20">
          <p>正确答案：{{ correctAnswer }}</p>
          <p>你的答案：{{ !currentAnswer ? '未作答' : currentAnswer }}</p>
        </div>
        <p>【题目解析】<span v-html="$xss(question.analysis)"></span></p>
      </div>
    </div>
    <div class="btn-wrap">
      <a
        @click="prevQuestion"
        :style="`color: ${$store.state.theme.themeColor} border: 1px solid ${$store.state.theme.themeColor}`"
        v-if="!isFirst"
        class="prev-btn">上一题</a>
      <a
        type="primary"
        :style="`background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`"
        @click="nextQuestion"
        v-if="!isLast" class="next-btn">下一题</a>
    </div>
  </div>
</template>

<script>
import 'element-ui/packages/theme-chalk/src/radio.scss'
import { downloadData } from '@/utils'
import { get } from '@/utils/ajax'
import QuestionContentMixin from '@/mixins/QuestionContentMixin'

export default {
  mixins: [QuestionContentMixin],
  props: {
    question: {
      type: Object,
      default () {
        return {}
      }
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    isMaking: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      order: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
      currentAnswer: '',
      correctAnswer: '',
      isCorrect: false,
      toolUrl: '',
      editorFullScreen: false,
      refreshDom: false,
      judgeList: [
        {
          value: 1,
          name: '对'
        },
        {
          value: 2,
          name: '错'
        }
      ],
      blankBcm: 'https://public-static-edu.codemao.cn/eduexam/blank.bcm'
    }
  },
  mounted () {
    this.$nextTick(
      this.toolListener()
    )
  },
  watch: {
    question: {
      handler: function (val) {
        this.refreshDom = true
        this.currentAnswer = val.typeId === 2 ? [] : ''
        this.correctAnswer = val.typeId === 2 ? [] : ''
        if (val.answer) {
          switch (val.typeId) {
            case 1:
            case 6:
              this.currentAnswer = Number(val.answer)
              break
            case 2:
              val.answer.forEach((t, i) => {
                val.answer[i] = Number(t)
              })
              this.currentAnswer = val.answer.sort()
              break
            default:
              this.currentAnswer = val.answer
          }
        }
        switch (val.typeId) {
          case 1:
            this.correctAnswer = Number(val.choice.answer[0])
            break
          case 2:
            val.choice.answer.forEach((t, i) => {
              val.choice.answer[i] = Number(t)
            })
            this.correctAnswer = val.choice.answer.sort()
            break
          case 20:
            this.correctAnswer = val.blank.answer
            break
          case 6:
            this.correctAnswer = val.yesNo.answer
            break
          case 11:
            if (this.question.questionType === 0) {
              this.correctAnswer = val.kitten.answer_bcm.url
            }
            break
          case 10:
            this.correctAnswer = val.operation.test_datas
            break
        }
        // 渲染题目
        this.renderRawDescription(val.rawDescription)
        this.isCorrect = val.score !== 0
        if (val.questionType === 0 || val.questionType === 2 || val.questionType === 3) {
          this.urlEncode()
        }
        setTimeout(() => {
          this.refreshDom = false
        }, 100)
      },
      deep: false,
      immediate: true
    }
  },
  methods: {
    // 下载考试资料
    downloadExamData (url) {
      downloadData(url)
    },
    toolListener () {
      window.addEventListener('message', e => {
        const message = e.data
        switch (message.msg) {
          case 'wood_is_ready':
            this.initPython()
            break
        }
        switch (message.type) {
          case 'kitten_loaded':
            this.initKitten()
            if (this.question.kittenMaterialLoad === 1) { // 打开素材库
              this.$refs.editor.contentWindow.postMessage( // 展示素材库  注意：kitten@3.7.0版本后，素材库material_dialog配置为bool值
                { type: 'kitten_set_ui', content: { sprite_panel: { material_dialog: 'default' } } }, CONFIG.ide
              )
            }
            break
        }
      })
    },
    initKitten() { // 初始化kitten配置项
      const kitten = this.$refs.editor
      kitten.contentWindow.postMessage( // 展示文件按钮
        { type: 'kitten_set_ui', content: { header: { file: true } } }, CONFIG.ide
      )
      kitten.contentWindow.postMessage( // 展示保存作品到本地
        { type: 'kitten_set_ui', content: { header: { export_file: true } } }, CONFIG.ide
      )
      kitten.contentWindow.postMessage( // 展示设置按钮
        { type: 'kitten_set_ui', content: { header: { setting: true } } }, CONFIG.ide
      )
      kitten.contentWindow.postMessage( // 展示语言切换
        { type: 'kitten_set_ui', content: { header: { language: true } } }, CONFIG.ide
      )
    },
    initPython () {
      // 设为代码模式
      setTimeout(() => {
        this.$refs.editor.contentWindow.postMessage(
          { msg: 'set_default_mode', mode: 'code' }, CONFIG.python
        )
      }, 100)
      setTimeout(() => {
        this.$refs.editor.contentWindow.postMessage(
          { msg: 'set_mode_btn_display', mode: 'false' }, CONFIG.python
        )
      }, 100)
      // 隐藏自带的缩放按钮
      setTimeout(() => {
        this.$refs.editor.contentWindow.postMessage(
          { msg: 'set_fullscreen_btn_display', is_display: false }, CONFIG.python
        )
      }, 100)
      // 设置初始化代码
      setTimeout(() => {
        this.$refs.editor.contentWindow.postMessage(
          { msg: 'set_python_code', code: this.currentAnswer }, CONFIG.python
        )
      }, 100)
    },
    showFullScreen () {
      if (this.question.questionType === 2) {
        this.$refs.editor.style.width = document.body.clientWidth
        this.$refs.editor.style.height = document.body.clientHeight
        setTimeout(() => {
          this.$refs.editor.contentWindow.postMessage(
            { msg: 'set_fullscreen_done',
              is_fullscreen: true }, CONFIG.python
          )
        }, 100)
      }
      this.editorFullScreen = true
    },
    outFullScreen () {
      if (this.question.questionType === 2) {
        setTimeout(() => {
          this.$refs.editor.contentWindow.postMessage(
            { msg: 'set_fullscreen_done',
              is_fullscreen: true }, CONFIG.python
          )
        }, 100)
      }
      this.editorFullScreen = false
    },
    async urlEncode () {
      if (this.question.questionType === 2) {
        this.toolUrl = CONFIG.python
      } else if (this.question.questionType === 0) {
        if (this.isMaking) { // 查看考生答卷
          this.toolUrl = `${window.CONFIG.ide}?code=${this.currentAnswer}&pid=egLIJPgY`
        } else { // 预览试卷
          const data = await get(`/edu/exams/works/kitten/code`, {
            bcm: this.question.questionOption.kitten.start_bcm.url || this.blankBcm
          })
          const code = this.currentAnswer || data
          this.toolUrl = `${window.CONFIG.ide}?code=${code}&pid=egLIJPgY`
        }
      } else {
        this.toolUrl = `${window.CONFIG.scratch}?work_url=${this.question.answer || this.question.uploadUrl}`
      }
    },
    prevQuestion () {
      this.$emit('prevQuestion', this.question.questionId)
    },
    nextQuestion () {
      this.$emit('nextQuestion', this.question.questionId)
    }
  }
}
</script>
<style>
.el-image-viewer__mask{
  cursor: pointer;
}
.el-image-viewer__close{
  top: 80px;
  width: 48px;
  height: 48px;
  background: rgba(0, 0, 0, 0.4);
}
.el-icon-circle-close::before{
  content: "\e6db";
  color: #fff;
  font-size: 24px;
  line-height: 48px;
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
  .question-content {
    height: 100%;
    flex: 1;
    background-color: #fff;
    box-shadow:0 0 20px 0 rgba(0, 0, 0, .1);
    border-radius: 8px 8px 0 0;
    padding: 20px;
    position: relative;
    .scroll-box {
      position: relative;
      height: calc(100% - 53px);
      padding-top: 20px;
      padding-bottom: 82px;
      overflow: scroll;
      &::-webkit-scrollbar {
        width: 10px;
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: #666;
      }
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 10px;
        background: #f7f7f7;
      }
    }
    /deep/ .el-radio__input.is-checked .el-radio__inner {
      background-color: #397EFD;
      border-color: #397EFD;
    }
    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: #397EFD;
    }
    /deep/ .el-radio__input + .el-radio__label {
      color: #333;
      font-weight: 400;
    }
    /deep/ .el-radio__inner:hover {
      border-color: #397EFD;
    }
  }
  .inner-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;
    border-bottom: 1px solid #f2f7ff;
    .type-name {
      font-size: 24px;
      color: #333;
      line-height: 32px;
      .score {
        color: #666;
      }
    }
  }
  .question-desc {
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 27px;
    letter-spacing: .5px;
    max-width: 960px;
    /deep/ img {
      max-width: 100%;
      max-height: 360px;
      width: auto;
      height: auto;
    }
  }
  .blank-wrap {
    position: relative;
    margin-bottom: 30px;
    .blank-fill {
      width: 420px;
      height: 42px;
      border: 1px solid #397EFD;
      border-radius: 4px;
      padding-left: 20px;
      font-size: 16px;
      &::placeholder {
        font-size: 16px;
        color: #bbb;
      }
    }
    .flag {
      position: absolute;
      display: inline-block;
      left: 380px;
      top: 0;
      line-height: 50px;
    }
  }
  .tool-wrap {
    width: 500px;
    height: 333px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    .editor {
      width: 100%;
      height: 100%;
      transition: all 0.4s linear;
      &.full-screen {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 2;
      }
    }
    .full-screen-btn {
      position: fixed;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
      z-index: 3;
      display: flex;
      flex-direction: column;
      button {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.15);
        cursor: pointer;
        transition: background-color .1s ease-in-out;
        padding: 0;
        &:hover {
          background: #397EFD;
          &:after {
            font-size: 14px;
            color: #fff;
            line-height: 20px;
            padding: 10px 16px;
            display: inline-block;
            width: 60px;
            height: 60px;
            box-sizing: border-box;
            border-radius: 50%;
          }
        }
      }
      .title-tip {
        background: #397EFD url('./title_tip@2x.png') no-repeat center / 27px 33px;
        margin-bottom: 15px;
        position: relative;
        &:hover {
          &:after {
            content: '查看题目';
          }
          .tip {
           visibility: visible;
            opacity: 1;
          }
        }
        .tip {
          visibility: hidden;
          position: absolute;
          right: 70px;
          top: 50%;
          transform: translateY(-50%);
          width: 600px;
          height: 400px;
          background-color: #fff;
          border-radius: 8px;
          box-shadow:0 8px 16px 0 rgba(0, 0, 0, .1);
          padding: 20px;
          text-align: left;
          opacity: 0;
          transition: opacity .1s linear;
        }
      }
      .out-full-screen {
        background: #fff url('./full_screen@2x.png') no-repeat center / 30px;
        &:hover {
          &:after {
            font-size: 13px;
            content: '退出全屏';
          }
        }
      }
    }
    .mask {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, .5);
    }
    .toAnswer {
      width: 100%;
      line-height: 33px;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 24px;
      font-weight: 300;
      cursor: pointer;
      .arrow {
        background: url('./full_screen_arrow@2x.png') no-repeat center / cover;
        width: 23px;
        height: 18px;
        margin-left: 10px;
      }
    }
  }
  .new-type-wrap  {
    .upload-wrap {
      width: 100%;
      padding: 30px 0 30px 13px;
      color: #111;
      font-size: 16px;
      background-color: #FAFAFA;
      .tip {
        margin-bottom: 20px;
      }
      .answer-wrap {
        padding: 5px 0 0 75px;
        height: 55px;
        position: relative;
        display: flex;
        .python-icon {
          position: absolute;
          top: 0;
          left: 0;
          width: 55px;
          height: 55px;
          background: url('~images/python-icon.png') center / cover no-repeat;
        }
        .answer-info {
          width: 256px;
          color: #333;
          font-size: 16px;
          line-height: 25px;
          .file-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .upload-time {
            color: #999;
            font-size: 14px;
          }
        }
        .change-btn {
          line-height: 25px;
          font-size: 16px;
          color: #377DFD;
          cursor: pointer;
          margin-left: 20px;
        }
      }
    }
    .data-upload, .data-download {
      display: flex;
      align-items: center;
      height: 42px;
      padding: 0 30px;
      border: 1px solid #397EFD;
      border-radius: 4px;
      color: #397EFD;
      font-size: 16px;
      line-height: 22px;
      cursor: pointer;
      background-color: #fff;
      .download-icon, .upload-icon {
        display: inline-block;
        width: 19px;
        height: 18px;
        background: url('~images/nct-download.png') no-repeat center / cover;
        margin-right: 9px;
      }
      .upload-icon {
        background: url('~images/nct-upload.png') no-repeat center / cover;
      }
    }
    .data-download {
      margin: 0 0 25px 13px;
    }
  }
  .option-wrap {
    display: inline-block;
    .option {
      display: flex;
      border-radius: 8px;
      border: 1px solid #efefef;
      margin-bottom: 20px;
      overflow: hidden;
      padding-right: 15px;
      min-width: 480px;
      max-width: 70%;
      .option-name-wrap {
        flex: 0 0 35px;
        background-color: #F5F9FF;
        margin-right: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px 0 0 5px;
      }
      .option-content {
        display: flex;
        flex-direction: column;
        padding: 18px 0;
        // width: 454px;
        .desc {
          width: 100%;
        }
        .image {
          max-width: 100%;
          display: block;
          border-radius: 4px;
        }
      }
    }
    .no-answer {
      align-self: center;
      position: absolute;
      left: 530px;
      margin-left: 0;
    }
  }
  .no-answer {
    width: 50px;
    font-size: 12px;
    color: #FF4E4E;
    margin-left: 20px;
  }
  .btn-wrap {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 82px;
    width: 100%;
    background: rgba(255, 255, 255, .9);
    display: flex;
    padding: 0 20px;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #F2F7FF;
    a {
      display: inline-block;
      width: 160px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      border-radius: 4px;
      background: #fff;
    }
    .prev-btn {
      color: #397EFD;
      border: 1px solid rgba(57,126,253,1);
      margin-right: 30px;
    }
    .next-btn {
      background-color: #397EFD;
      border-color: #397EFD;
      color: #fff;
      &:hover {
        opacity: .8;
      }
    }
  }
  .answer-wrap {
    font-size: 14px;
    color: #FF9743;
    margin-top: 20px;
    /deep/ .image-wrap img {
      max-width: 465px;
    }
  }
  .link-color {
    color: #397EFD;
  }
  .is-correct-input {
    border: 2px solid #00C882 !important;
    color: #00C882;
    &.option .option-name-wrap {
      background-color: #00C882;
      color: #fff;
    }
  }
  .is-error-input {
    border: 2px solid #FF4E4E !important;
    background: rgba(255, 78, 78, .1);
    color: #FF4E4E;
    &.option .option-name-wrap {
      background-color: #FF4E4E;
      color: #fff;
    }
  }
  .flag {
    align-self: center;
    margin-left: 10px;
    i {
      display: inline-block;
    }
    .icon-correct {
      width: 17px;
      height: 12px;
      background: url("./icon-correct.png") center / cover no-repeat;
    }
    .icon-error {
      width: 14px;
      height: 14px;
      background: url("./icon-error.png") center / cover no-repeat;
    }
  }
</style>
